<template>
  <div class="terms-view relative h-full">
    <p class="text-left">
      {{ $t("landing.terms_and_conditions_description") }}
    </p>
    <div class="flex mt-5">
      <db-checkbox
        label=""
        name=""
        @change="(e) => toggleCondition('general_terms_and_conditions')"
        id="general_terms_and_conditions"
      ></db-checkbox>
      <label
        for="general_terms_and_conditions"
        v-html="$t('landing.general_terms_and_conditions')"
        class="text-left"
      ></label>
    </div>
    <div class="flex mt-5">
      <db-checkbox
        label=""
        name=""
        @change="(e) => toggleCondition('link2rail_terms_of_use')"
        id="link2rail_terms_of_use"
      ></db-checkbox>
      <label
        for="link2rail_terms_of_use"
        v-html="$t('landing.link2rail_terms_of_use')"
        class="text-left"
      ></label>
    </div>
    <div class="flex mt-5">
      <db-checkbox
        label=""
        name=""
        @change="(e) => toggleCondition('link2rail_data_protection_notice')"
        id="link2rail_data_protection_notice"
      ></db-checkbox>
      <label
        for="link2rail_data_protection_notice"
        v-html="$t('landing.link2rail_data_protection_notice')"
        class="text-left"
      ></label>
    </div>
    <div
      id="accept-button"
      class="fixed z-19 bottom-[80px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col"
    >
      <db-button
        @click="submit"
        class="hydrated"
        variant="brand-primary"
        :disabled="notAllTermsAccepted"
      >
        {{ $t("landing.accept") }}
      </db-button>

      <db-button @click="logout" class="hydrated" variant="tertiary-plain">
        {{ $t("main.logout") }}
      </db-button>
    </div>
  </div>
</template>

<script lang="ts">
import { useCookies } from "vue3-cookies";
import firebaseAuthService from "@/services/FirebaseAuthService";
import { defineComponent, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { COOKIE_TERMS_ACCEPTED } from "@/utils/constants";
import {
  DbButton,
  DbCheckbox,
} from "@db-ui/v-elements-enterprise/dist/components";
const { cookies } = useCookies();

type TermType =
  | "general_terms_and_conditions"
  | "link2rail_terms_of_use"
  | "link2rail_data_protection_notice";

export default defineComponent({
  name: "TermsView",
  setup() {
    const store = useStore();
    const terms = ref({
      general_terms_and_conditions: false,
      link2rail_terms_of_use: false,
      link2rail_data_protection_notice: false,
    });

    const toggleCondition = (termType: TermType) => {
      console.log(termType);
      const previousVal = terms.value[termType];
      terms.value[termType] = !previousVal;
      console.log(terms.value);
    };

    const notAllTermsAccepted = computed(() => {
      return Object.values(terms.value).some((term) => term != true);
    });

    const submit = async () => {
      await store
        .dispatch("UserStore/getTermsAccepted", store.state.user.data.user_id)
        .then((response) => {
          const data = {
            terms: response,
            userId: store.state.user.data.user_id,
          };
          store.dispatch("UserStore/setTermsAccepted", data);
          router.push("/");
        });
    };

    const router = useRouter();
    const logout = async () => {
      cookies.remove(COOKIE_TERMS_ACCEPTED);
      await firebaseAuthService.logout();
      router.push("/login");
    };

    return {
      submit,
      notAllTermsAccepted,
      logout,
      store,
      toggleCondition,
    };
  },
  components: { DbButton, DbCheckbox },
});
</script>
<style>
label > a {
  text-decoration: underline;
}
</style>
